import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { openEvent, rescheduleEvent,rescheduleEventExplicit } from '../../../../redux/calendar';
import { toggleDeleteModal, toggleApptEditModal } from '../../../../redux/modals';
import { open as togglePrintWorkOrderModal } from '../../../../redux/modals/printWorkOrderModal';
import AppointmentEvent from './AppointmentEvent';

const colorMode = (state) => state.settings.color;

const colors = createSelector(
  colorMode,
  (state) => state.dropdowns,
  (colorMode, { jobStatuses, jobTypes, offices }) => {
    switch (colorMode) {
      case 'jobStatus':
        return jobStatuses;
      case 'office':
        return offices;
      default:
        return jobTypes;
    }
  }
);

const getEvent = (state, { eventId }) => state.events.events.find((e) => e.id === eventId);

const makeGetEvent = () => createSelector(
  getEvent,
  colorMode,
  colors,
  (event, colorMode, colors) => {
    
    if (!event.datasheet) {
      return event;
    }

    let color = null;
    switch (colorMode) {
      case 'office':
        const office = colors.find((office) => event.datasheet.office && office.id === event.datasheet.office.id);
        color = office ? office.color : null;
        break;
      case 'salesperson':
        const salesperson = event.datasheet.salesperson;
        color = salesperson ? salesperson.calendarColor : null;
        break;
      default:
        return event;
    }
    return { ...event, color };
  }
);

const makeMapStateToProps = () => {
  const getEvent = makeGetEvent();
  return (state, props) => ({
    detailEnabled: state.settings.detailEnabled,
    entity: state.settings.entity,
    event: getEvent(state, props),
    financialEnabled: state.settings.financialEnabled,
    hasCalendarEventDelete: state.tokenInfo.scope.indexOf('calendarEvents:delete') > -1,
    hasCalendarEventUpdate: state.tokenInfo.scope.indexOf('calendarEvents:update') > -1,
    locationEnabled: state.settings.locationEnabled,
    materialEnabled: state.settings.materialEnabled,
    mode: state.calendar ? state.calendar.mode: 'week'
  });
};

const mapDispatchToProps = (dispatch, { eventId }) => ({
  onClick: () => dispatch(rescheduleEvent(eventId)),
  onOpenClick: () => dispatch(openEvent(eventId)),
  onRescheduleRes: (eventId, date,crew,mode)=> dispatch(rescheduleEventExplicit(eventId, date,crew,mode)),
  onDeleteEventClick: () => dispatch(toggleDeleteModal(eventId)),
  onEditEventClick: () => dispatch(toggleApptEditModal(eventId)),
});

const mergeProps = ({ event, hasCalendarEventDelete, hasCalendarEventUpdate, ...stateProps }, { onClick, onDeleteEventClick, onEditEventClick, onPrintWorkOrder, ...dispatchProps }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  event,
  onClick: hasCalendarEventUpdate ? onClick : null,
  onDeleteEventClick: hasCalendarEventDelete ? onDeleteEventClick : null,
  onEditEventClick: hasCalendarEventUpdate ? onEditEventClick : null,
});

export default connect(makeMapStateToProps, mapDispatchToProps, mergeProps)(AppointmentEvent);
